<script setup>
import { getTimeStr, joinNames, getResult } from './filters';
import { SCORE_TYPES, RECTIFICATION_STATE } from '../../../../utils/const'
import GalleryBox from '../../../../components/GalleryBox'

defineProps({
    tir: {
        type: Object,
        required: true
    }
})

function _switchExpandState(e) {
    if (e) {
        const $i = e.target
        if ($i && $i.parentElement && $i.parentElement.parentElement) {
            const $content = $i.parentElement.parentElement.nextElementSibling
            if ($content && $content.style) {
                if ($content.style.display === "none") {
                    $i.className = 'el-icon-arrow-up'
                    $content.style.display = "block"
                } else {
                    $i.className = 'el-icon-arrow-down'
                    $content.style.display = "none"
                }                
            }
        }        
    }
}
</script>
<template>
    <div v-if="Array.isArray(tir.correctDetails) && tir.correctDetails.length" class="rectification-wrap">
        <div class="rectification-item mb10" v-for="(correct, index) in tir.correctDetails" :key="index">
            <div class="header">
                <div class="left">
                    <div class="index">
                        {{ index + 1 > 9 ? index + 1 : "0" + (index + 1) }}
                    </div>
                    <div class="information">整改信息</div>
                    <div class="division"></div>
                    <div class="red">
                        {{ RECTIFICATION_STATE[Number.isInteger(correct.state) ? correct.state : 0] }}
                    </div>
                </div>
                <div class="right">
                    <i class="el-icon-arrow-down" @click="_switchExpandState"/>
                </div>
            </div>
            <div class="content" style="display: none;">
                <div class="requirement pb20">
                    <img class="icon" src="../../images/ask-for.png" alt=""/>
                    <div>
                        <div class="mb8" v-if="correct.corDemand">
                            {{ correct.corDemand }}
                        </div>
                        <div class="time">
                            <div class="left">
                                截止时间: {{ getTimeStr(correct.deadline) }}
                            </div>
                            <div class="right ellipsis">
                                受理人:{{ joinNames(correct.processors) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="requirement"
                    v-if="!!correct.state &&
                        correct.state != 1 &&
                        correct.state != 2 &&
                        correct.state != 4 &&
                        correct.state != 5">
                    <img class="icon" src="../../images/result.png" alt=""/>
                    <div>
                        <div class="mt40" v-for="item in correct.correctItems" :key="item.id">
                            <div class="title preWrap">{{ item.describle }}</div>
                            <div v-if="tir.type != 9" class="describe preWrap mt8">
                                {{ getResult(item) }}
                                <span v-if="SCORE_TYPES.includes(item.type) && Number(item.fullScore) > 0">（{{ item.score + "分" }}）</span>
                            </div>
                            <GalleryBox class="mt8" v-if="Array.isArray(item.images) && item.images.length" :attaList="item.images"/>
                        </div>
                        <div class="time">
                            整改时间:{{ getTimeStr(correct.flow[0].submitTime) }}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            整改人:{{ correct.flow[0].submitter }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<style lang="less" scoped>
.rectification-wrap {
    margin-top: 10px;
    .rectification-item {
        background: #f9fafe;
        font-size: 14px;
        border-radius: 6px;
        overflow: hidden;
        .header {
            height: 30px;
            padding: 0 25px;
            border-bottom: 2px solid #ecf3fc;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
                display: flex;
                align-items: center;
                .index {
                    font-size: 14px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #4a5462;
                    margin-right: 10px;
                }
                .information {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4a5462;
                }
                .division {
                    width: 4px;
                    height: 22px;
                    background-color: #e7ebf6;
                    margin: 0 10px;
                }
            }
        }
        .content {
            padding: 12px 25px;
            .requirement {
                display: flex;
                .icon {
                    position: relative;
                    // top: 4px;
                    width: 33px;
                    height: 19.5px;
                    margin-right: 10px;
                }
                .describe {
                    color: #5f768d;
                }
                .time {
                    width: 100%;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #5f768d;
                    .left {
                        margin-right: 30px;
                    }
                }
            }
        }
    }
}
</style>